export default __webpack_public_path__ + "static/media/banner-div.020dd35c.svg";